import axios from "axios";

import { DataGridRequestParams } from "fe-shared-transactions/src/types";

import { PAGE_SIZE } from "../../../consts";
import {
  GridInventoryAdjustment,
  GridInventoryAdjustmentList,
} from "../../../types/inventoryAdjustments";

export const getInventoryAdjustments = (
  queryKey: string,
  requestParams: DataGridRequestParams,
  page: number | null = 1
): Promise<GridInventoryAdjustmentList<GridInventoryAdjustment>> =>
  axios
    .post<GridInventoryAdjustmentList<GridInventoryAdjustment>>(
      "/getOverallAdjustments",
      {
        ...requestParams,
        ...(page !== null
          ? { limit: PAGE_SIZE, skip: PAGE_SIZE * (page - 1) }
          : {}),
      }
    )
    .then((res) => res.data);

export default {
  getInventoryAdjustments,
};
